import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/ui/other/jpg-png/burger-menu-link-radioguide-rent.png")